const LAST_RELOAD_KEY = "autou:vite-preload-reload-at";
const RELOAD_COOLDOWN_MS = 10_000;

interface VitePreloadRecoveryOptions {
  target?: Pick<EventTarget, "addEventListener" | "removeEventListener">;
  storage?: Pick<Storage, "getItem" | "setItem">;
  reload?: () => void;
  now?: () => number;
}

export function registerVitePreloadRecovery({
  target = window,
  storage = window.sessionStorage,
  reload = () => window.location.reload(),
  now = Date.now,
}: VitePreloadRecoveryOptions = {}) {
  let reloadRequested = false;

  const handlePreloadError = (event: Event) => {
    event.preventDefault();
    if (reloadRequested) return;

    const currentTime = now();
    let lastReloadAt = 0;
    try {
      lastReloadAt = Number(storage.getItem(LAST_RELOAD_KEY)) || 0;
    } catch {
      // sessionStorage pode estar indisponivel em navegacao privada restrita.
    }

    if (currentTime - lastReloadAt < RELOAD_COOLDOWN_MS) return;

    reloadRequested = true;
    try {
      storage.setItem(LAST_RELOAD_KEY, String(currentTime));
    } catch {
      // O bloqueio do storage nao deve impedir a recuperacao desta pagina.
    }
    reload();
  };

  target.addEventListener("vite:preloadError", handlePreloadError);
  return () => target.removeEventListener("vite:preloadError", handlePreloadError);
}